import { Box } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { ReactNode } from "react";
import { FullScreenViewerProps } from "../../../../components/common/FullScreenViewer/FullScreenViewer";
import { BriaImageProps, ImageErrorType } from "../../../../components/common/Galleries/BriaImage";
import { PlaygroundImage, PlaygroundResult } from "../../../../models/image-to-image";
import LabGalleryView from "../GalleryView/LabGalleryView";
import styles from "./LabImageResult.module.scss";

export type LabImageResultProps = {
	playgroundResult: PlaygroundResult;
	headerContent?: ReactNode;
	footerControls?: ReactNode;
	renderImageOverlay?: (image: PlaygroundImage) => ReactNode;
	renderImageExtra?: (
		image: PlaygroundImage,
		imageElement: HTMLImageElement | null,
		isSelected: boolean,
	) => ReactNode;
	getImageProps?: (image: PlaygroundImage) => Partial<BriaImageProps>;
	fullScreenProps?: Partial<FullScreenViewerProps>;
	onSuccessPulling?: (image: PlaygroundImage, result?: any) => void;
	onErrorPulling?: (image: PlaygroundImage, errorType: ImageErrorType) => void;
	onSelectedImageChange?: (image: PlaygroundImage, index: number) => void;
	abortController?: AbortController;
	className?: string;
	onImageSelect?: (image: PlaygroundImage, index: number) => void;
	isSelected?: boolean;
	anonymousFeature?: string;
};

const LabImageResult = ({
	playgroundResult,
	headerContent,
	footerControls,
	renderImageOverlay,
	renderImageExtra,
	getImageProps,
	fullScreenProps,
	onSuccessPulling,
	onErrorPulling,
	onSelectedImageChange,
	abortController,
	className,
	onImageSelect,
	isSelected,
	anonymousFeature,
}: LabImageResultProps) => {
	return (
		<Box className={clsx(styles.labImageResult, className)}>
			{headerContent && <Box className={styles.header}>{headerContent}</Box>}
			<LabGalleryView
				playgroundResult={playgroundResult}
				fullScreenProps={fullScreenProps}
				renderImageOverlay={renderImageOverlay}
				renderImageExtra={renderImageExtra}
				getImageProps={getImageProps}
				onSuccessPulling={onSuccessPulling}
				onErrorPulling={onErrorPulling}
				onSelectedImageChange={onSelectedImageChange}
				abortController={abortController}
				footerControls={footerControls}
				onImageSelect={onImageSelect}
				isSelected={isSelected}
				anonymousFeature={anonymousFeature}
			/>
		</Box>
	);
};

export default observer(LabImageResult);
